import { render } from "./DeliverBy.vue?vue&type=template&id=4be597ad&scoped=true"
import script from "./DeliverBy.vue?vue&type=script&lang=js"
export * from "./DeliverBy.vue?vue&type=script&lang=js"

import "./DeliverBy.vue?vue&type=style&index=0&id=4be597ad&scoped=true&lang=css"

import exportComponent from "F:\\CodeBrix\\My Porter\\WECCO-UserFlow\\MyPorter\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4be597ad"]])

export default __exports__